/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllStateTownsResponse } from './FindAllStateTownsResponse';
import {
    FindAllStateTownsResponseFromJSON,
    FindAllStateTownsResponseFromJSONTyped,
    FindAllStateTownsResponseToJSON,
} from './FindAllStateTownsResponse';

/**
 * 
 * @export
 * @interface FindAllStateTowns200Response
 */
export interface FindAllStateTowns200Response {
    /**
     * 
     * @type {FindAllStateTownsResponse}
     * @memberof FindAllStateTowns200Response
     */
    data?: FindAllStateTownsResponse;
}

/**
 * Check if a given object implements the FindAllStateTowns200Response interface.
 */
export function instanceOfFindAllStateTowns200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllStateTowns200ResponseFromJSON(json: any): FindAllStateTowns200Response {
    return FindAllStateTowns200ResponseFromJSONTyped(json, false);
}

export function FindAllStateTowns200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStateTowns200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllStateTownsResponseFromJSON(json['data']),
    };
}

export function FindAllStateTowns200ResponseToJSON(value?: FindAllStateTowns200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllStateTownsResponseToJSON(value.data),
    };
}

